import React from 'react';

import OpenInNewIcon from '@mui/icons-material/OpenInNewRounded';
import { Link } from '@mui/material';
import { observer } from 'mobx-react';

import classes from './ChallengeRow.module.scss';
import {
  GridTableCell,
  GridTableRow,
} from '../../../../shared/components/table-components';
import { ChallengeRowInfo } from '../../../interfaces/challenges-list/ChallengeRowInfo';
import { getFormattedLocalDate } from '../../../../shared/utils/dateUtils';
import { localDataFormat } from '../../../../shared/constants/apiDateFormat';
import { ChallengeStatusCell } from './ChallengeStatusCell/ChallengeStatusCell';
import { getHumanizeChallengeCustomerType } from '../../../utils/getHumanizeChallengeCustomerType/getHumanizeChallengeCustomerType';
import { loggedInUserDataStore } from '../../../../shared/stores/loggedInUserDataStore';

type ChallengeRowProps = {
  challenge: ChallengeRowInfo;
};

const ChallengeRow = observer(({ challenge }: ChallengeRowProps) => {
  const { isSuperAdmin, isEntity, isCoach } = loggedInUserDataStore;

  const {
    challengeId,
    challengeName,
    entityName,
    customerType,
    startDate,
    endDate,
    challengeStatus,
    participantCount,
  } = challenge;

  return (
    <GridTableRow variant="row">
      <GridTableCell variant="title">
        <Link href={`#!/challenge-profile/${challengeId}`}>{challengeName}</Link>
      </GridTableCell>
      {isSuperAdmin && <GridTableCell>{entityName}</GridTableCell>}
      <GridTableCell>
        {customerType ? getHumanizeChallengeCustomerType(customerType) : '-'}
      </GridTableCell>
      <GridTableCell>
        {startDate ? getFormattedLocalDate(startDate, localDataFormat) : '-'}
      </GridTableCell>
      <GridTableCell>
        {endDate ? getFormattedLocalDate(endDate, localDataFormat) : '-'}
      </GridTableCell>
      <ChallengeStatusCell status={challengeStatus} />
      {(isEntity || isCoach) && <GridTableCell>{participantCount}</GridTableCell>}
      <GridTableCell justify="end">
        <Link
          href={`#!/challenge-leaderboard/${challengeId}`}
          className={classes.leaderboardLink}
          target="_blank"
        >
          <OpenInNewIcon fontSize="small" />
          Show Leaderboard
        </Link>
      </GridTableCell>
    </GridTableRow>
  );
});

export { ChallengeRow };
